import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01ab9a03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box hide-small" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " MOTHERSHEET ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "subtitle" }, [
  /*#__PURE__*/_createTextVNode(" An Unofficial "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.mothershiprpg.com/home",
    target: "_blank"
  }, "Mothership"),
  /*#__PURE__*/_createTextVNode(" Character Sheet ")
], -1))
const _hoisted_4 = {
  ref: "button",
  class: "login-button"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-small box" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Small screens are not currently supported. "),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Check your app store for the official character sheet app. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarField = _resolveComponent("StarField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_StarField),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, null, 512)
    ]),
    _hoisted_5
  ], 64))
}